import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Container, Card, Button } from "react-bootstrap";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { getCookie, checkCookie } from "../../Utils/Utils";
import {  shopOnlineList,  setOrderList, addItemsToCart } from "../../../redux/action";
import { ENABLE_RESONATE_WEBSITE, EXCLUDE_LIST, ORDER_API, PRODUCT_SHOP_ONLINE, PRODUCT_SHOP_ONLINE_OB, PRODUCTS_API } from "../../../constants/Constants";
import Header from "../../Content/Header/Header";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@material-ui/core";

import axios from "axios";
import Categories from "../../Content/Categories/Categories";
import TokenMessage from "../../Content/TokenMessage/TokenMessage";
require("./ShopOnline.scss");

class ShopOnline extends Component {
  componentDidMount() {
    if (!checkCookie("emailId") || (!ENABLE_RESONATE_WEBSITE)) {
      this.setState({ redirect: true });
    } else {
      let email = getCookie("emailId");
      this.getUserDetails(email);
      
      if (this.props.shopOnline.length === 0) {
        let API = EXCLUDE_LIST.includes(email)? PRODUCT_SHOP_ONLINE_OB : PRODUCT_SHOP_ONLINE;
        axios
          .get(API)
          .then(response => {
            this.handleShopOnlineList(response.data.products);
          });
      }
    }
  }

  handleShopOnlineList(products) {
    this.props.shopOnlineList(products);
  }

  handleAddToCart(productId) {
      this.props.addItemsToCart(productId);
  }

  disableButton(product) {
    let disable = false;
    if (product.count >= product.maxItems || product.quantity === 0) {
      return disable = true;
    }
    return disable;
  }

  getUserDetails(email) {
    if (this.props.orders === undefined) {
      axios.get(ORDER_API + "?userId=" + getCookie("userId")).then(response => {
        this.props.setOrderList(response.data.orderList);
      });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      cookie: false,
      pageName: "shop-online",
      resonateExclusive: []
    };

    this.handleLike = this.handleLike.bind(this);
  }

  handleLike(productId) {
    axios.put(PRODUCTS_API + "/like/" + productId).then(response => {
      let email = getCookie("emailId");
      let API = EXCLUDE_LIST.includes(email)? PRODUCT_SHOP_ONLINE_OB : PRODUCT_SHOP_ONLINE;
      axios
          .get(API)
          .then(response => {
            this.handleShopOnlineList(response.data.products);
          });
    });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    const shopOnline = this.props.shopOnline;
    let email = getCookie("emailId");
    return (
      <Container className="page-container">
        <Header />
        <TokenMessage/>
        <Categories />
        <div className="message-ob">{EXCLUDE_LIST.includes(email)? "Online snack orders are temporarily restricted for  OB and TOC families. Please check back soon for updates.":""}</div>
        <Container className="shop-online-container">
          {Object.keys(shopOnline).map(key => (
            <Card className="shop-online-card" key={key}>
              <Card.Img className="shop-online-image" src={shopOnline[key].imageName} />
              <Card.Body className="shop-online-card-body">
                <Accordion>
                  <AccordionSummary className="shop-online-title">
                    {shopOnline[key].productName} <ExpandMoreIcon />
                  </AccordionSummary>
                  <AccordionDetails className="shop-online-description">
                    <p>{shopOnline[key].description} </p> 
                     {shopOnline[key].link && (
                      <a
                        className="shop-link"
                        href={shopOnline[key].link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Product link →
                      </a>
                    )}
                  </AccordionDetails>
                </Accordion>
                <Card.Text>
                  <span className="shop-online-price">{shopOnline[key].value} </span>
                  <span>tokens</span>
                  <span className="shop-online-quantity">
                      {shopOnline[key].quantity}{" "}
                  </span><span> item(s) left</span>
                </Card.Text>
                <Card.Text className="shop-online-alert" hidden={!(shopOnline[key].count >= shopOnline[key].maxItems)}>
                  You can only add {shopOnline[key].maxItems} items of the same type
                </Card.Text>
                <Button
                  className="shop-online-button"
                  disabled= {this.disableButton(shopOnline[key])}
                  onClick={() => {
                    this.handleAddToCart(shopOnline[key].productId);
                  }}
                  block
                >
                  {shopOnline[key].quantity === 0? "Sold Out": "Add To Cart"}
                </Button>
              </Card.Body>
            </Card>
          ))}
        </Container>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    shopOnline: state ? state.filterShopOnline : [],
    user: state ? state.user : null,
    orders: state ? state.orders : []
  };
};

const mapDispatchToProps = dispatch => {
  return {
    shopOnlineList: shopOnline => {
      dispatch(shopOnlineList(shopOnline));
    },
    setOrderList: orders => {
      dispatch(setOrderList(orders));
    },
    addItemsToCart: productId => {
      dispatch(addItemsToCart(productId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  pure: false
})(ShopOnline);
